module.exports = __webpack_public_path__ + "img/cup-0-stars.ac1dbebe.svg";